import "../index.css";
export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer-text">
        Made by Dulce Figueredo. The code is available on{" "}
        <a href="https://github.com/DulceFigueredo/reactjs-todolist">GitHub</a>.
      </p>
    </footer>
  );
}
